<template>
<div class="chapter">
<div class="inner_page">
<div class="alsoby">
<a id="title2"></a><div class="title-alsoby"><strong class="b">Books by Helen Brooks</strong></div>
<div class="p-br"><span>HARLEQUIN ROMANCE<sup>®</sup> <br/>3350—AND THE BRIDE WORE BLACK <br/>3378—ANGELS DO HAVE WINGS <br/>3434—DREAM WEDDING</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-br"><span>HARLEQUIN PRESENTS <br/>1914—THE PRICE OF A WIFE <br/>1934—HUSBAND BY CONTRACT <em class="i">(HUSBANDS &amp; WIVES #1)</em> <br/>1939—SECOND MARRIAGE <em class="i">(HUSBANDS &amp; WIVES #2)</em></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Don’t miss any of our special offers. Write to us at the following address for information on our newest releases</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-br"><span>Harlequin Reader Service <br/>U.S.: 3010 Walden Ave., PO Box 1325, Buffalo, NY 14269 <br/>Canadian P.O Box 609, Fort Erie, Ont L2A 5X3</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781459253025_als01.vue?1a90203e